import $ from "jquery";

const utilsSubmit = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: ".js-submit",
        };
        if ($(el.main).length === 0) return;

        $(document).on("click", el.main, function (e) {
            e.preventDefault();
            const form = $(this).data("form");

            $(form).trigger("submit");
        });
    };
    init();
};

try {
    utilsSubmit();
} catch (error) {
    console.error("utilsSubmit", error);
}
